import { enumBranchStyle } from "../constants";

export function IsRightStyle(branchStyle) {
  var rightStyle = false;
  switch (branchStyle) {
    case enumBranchStyle.onecolumncenterright:
    case enumBranchStyle.onecolumnright:
    case enumBranchStyle.assistantpeerright:
    case enumBranchStyle.assistantright:
      rightStyle = true;
      break;
  }

  return rightStyle;
}
